export default __webpack_public_path__ + "static/media/merit-award.f958ace6.png";